import { FC } from 'react';
import { Content } from '@prismicio/client';

import { BorrowMoreColumn1, BorrowMoreColumn2, IconDataBase } from '@/assets';

import styles from './cards.module.scss';

type Props = {
  slice: Content.BorrowMoreSlice;
  isVisible: boolean;
};

export const Cards: FC<Props> = ({ slice, isVisible }) => {
  return (
    <article className={styles.cardsWrapper}>
      <ul className={styles.cardsList}>
        {slice.primary.cards.map((item, index) => {
          const currentIndex = index + 1;

          return (
            <li
              key={index}
              className={`${styles.cardItem} ${styles[`cardItem-${currentIndex}`]} ${isVisible ? styles.isVisible : ''}`}
            >
              <div className={`${styles.box} ${styles[`box-${currentIndex}`]}`}>
                <p
                  className={`${styles.boxTitle} ${styles[`boxTitle-${currentIndex}`]}`}
                >
                  {item.title}
                </p>

                {currentIndex === 2 && (
                  <div className={styles.icon}>
                    <IconDataBase />
                  </div>
                )}

                {currentIndex === 2 && (
                  <div className={styles.columns}>
                    <BorrowMoreColumn1 className={styles.column} />
                    <BorrowMoreColumn2 className={styles.column} />
                  </div>
                )}

                {item.heading_text && item.heading_value && (
                  <div
                    className={`${styles.cardBottom} ${styles[`cardBottom-${currentIndex}`]}`}
                  >
                    <p className={styles.headingText}>{item.heading_text}</p>
                    <p className={styles.headingValue}>{item.heading_value}</p>
                  </div>
                )}
              </div>
            </li>
          );
        })}
      </ul>
    </article>
  );
};
